// extracted by mini-css-extract-plugin
module.exports = {"links":"links-module--links--ExRMV","linksList":"links-module--links-list--3dUkB","linksListItem":"links-module--links-list-item--NT2qq"};